module.exports = __webpack_public_path__ + "img/dashboard_es_mobile.5d3128c.png";